<template>
  <div class="liveShare">
    <div class="liveShare-title">{{listData.liveName}}</div>
    <div class="liveShare-card" :style="{'backgroundImage': 'url('+backgroundImage+')'}" @click="clickEvent">
      <div class="head-item">
        <img :src="listData.anchorImgUrl" alt="" class="head-portrait" v-if="listData.anchorImgUrl">
        <img src="@/assets/user_default.png" alt="" class="head-portrait" v-else>
        <div class="live-tag">
          <label class="live-tag-icon">
            <span class="iconfont icon-zhibo"></span>
            <span v-if="listData.liveState ==1">{{ $t('share.pending') }}</span>
            <span v-else-if="listData.liveState ==2">{{ $t('share.live') }}</span>
            <span v-else-if="listData.liveState ==3">{{ $t('share.finish') }}</span>
          </label>
          <div class="person-info">
            <span class="info-post">{{listData.anchorPost}}</span>
            <span class="info-name">{{listData.anchorName}}</span>
          </div>
        </div>
      </div>
      <div class="join-live">
        <div class="join-live-2" v-if="listData.liveState ==2">
          <span class="iconfont icon-zhibo"></span>
          <span>{{ $t('share.enter')}}</span>
        </div>
      </div>
      <div class="foot-part">
        <div class="foot-part-rigth">
          <label class="circle">
            <i class="iconfont"
              :class="{'icon-xiangkan':listData.liveState ==1,'icon-act_dianzan_full':listData.liveState !=1}"></i>
          </label>
          <span class="foot-part-right-item" v-if="listData.liveState ==1">{{ $t('share.interested') }}</span>
          <span class="foot-part-right-item" v-else>{{ $t('share.likes') }}</span>
          <span class="foot-part-right-item" v-if="listData.liveState ==1">{{listData.liveWantCount}}</span>
          <span class="foot-part-right-item" v-else>{{listData.liveLikeCount}}</span>
        </div>
        <div class="foot-part-left">
          <span class="foot-part-left-item">{{ $t('share.time') }}</span>
          <span class="line"></span>
          <span class="foot-part-left-item">{{listData.liveStartDate | formatDate(12)}}</span>
          <span class="foot-part-left-item">{{listData.liveStartDate | formatDate(9)}}</span>
        </div>
      </div>
    </div>
    <div class="want-see">
      <span>{{listData.liveWantCount}}</span>
      <span v-if="listData.liveState ==1">{{ $t('share.interested') }}</span>
      <span v-if="listData.liveState ==2">{{ $t('share.looking') }}</span>
      <span v-if="listData.liveState ==3">{{ $t('share.seen') }}</span>
    </div>
    <div class="head-portrait-list">
      <template v-for="wantSeeList in listData.wantSeeList">
        <img :src="wantSeeList.userImg" alt="" class="head-portrait" :key="wantSeeList.userAccountId">
      </template>
    </div>
    <div class="exhibitor-info" @click="clickEvent" v-if="listData.liveParty == 2">
      <span class="exhibitor-company">
        {{listData.liveSponsorName}}
      </span>
      <label class="exhibitor-info-del">{{ $t('share.exhibits')}}</label>
    </div>
    <div class="intro">
      <span class="intro-title">{{ $t('share.introduction') }}</span>
      <span class="intro-content">{{listData.liveDesc}}</span>
    </div>
    <div class="head-portrait-list productList">
      <template v-for="productList in listData.productList">
        <img :src="productList.icon" class="productList-img" :key="productList.id">
      </template>
    </div>
    <openappview openKey="LiveDetail"></openappview>
  </div>
</template>

<script>
import openappview from '../../components/openAppView'

export default {
  components:{
    openappview
  },
  data () {
    return {
      isExhibitor: true, //showType =ACTOR  或者  showType =VISITOR
      listData: "",
      liveId: "",
      languageType: "cn"
    }
  },
  mounted () {
    this.isExhibitor = this.$route.query.showType == "ACTOR" ? false : true;
    this.liveId = this.$route.query.liveId;
    this.languageType = this.$route.query.languageType;
    this.$i18n.locale = this.languageType;
    this.getLiveDetail();
  },
  computed: {
    backgroundImage () {
      return this.listData.liveImgUrl ? this.listData.liveImgUrl : require('@/assets/bg.png');
    }
  },
  methods: {
    clickEvent () {
      this.$tools.lookApp();
    },
    getLiveDetail () {
      let params = {
        languageType: this.languageType,
        liveId: this.liveId
      };
      this.$http.liveDetail(params).then(res => {
        if (res.code == 1000) {
          this.listData = res.data;
          if (this.$utils.isWeiXin()) {
            const { liveName, liveDesc, shareImgUrl } = this.listData
            const config = {
              title: liveName,
              desc: liveDesc,
              imgUrl: shareImgUrl
            }
            this.$utils.wxShareConfig(config)
          }
        }
      }).catch(error => {
        console.log(error)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.liveShare {
  background: #f5f6fa;
  min-height: 100%;
  padding: 0 16px;
}
.liveShare-title {
  display: flex;
  margin: 28px 0;
  justify-content: center;
}
.liveShare-card {
  display: flex;
  flex-direction: column;
  background-image: url(~@/assets/bg.png);
  margin: 0;
  background-position: center;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  color: #ffffff;
  min-height: 190px;
  border-radius: 10px 10px 0 0;
}
.head-item {
  display: flex;
  margin: 10px;
  flex-direction: row;
}
.head-portrait {
  width: 40px;
  height: 40px;
  border-radius: 100%;
}
.live-tag {
  margin-left: 10px;
  &-icon {
    background: rgba(229, 0, 56, 1);
    border-radius: 2px;
    padding: 2px 6px;
    font-size: 12px;
    margin-bottom: 20px;
  }
}
.person-info {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  text-shadow: 0px 1px 2px rgba(0, 0, 0, 1);
  margin-top: 2px;
  .info-name {
    margin-left: 4px;
  }
}
.join-live {
  display: flex;
  justify-content: center;
  margin-top: 38px;
}
.join-live-2 {
  background: #3385ff;
  padding: 4px 10px;
  border-radius: 4px;
}
.foot-part {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 0 10px;
  flex: 1;
}
.foot-part-rigth,
.foot-part-left {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 13px;
  color: rgba(255, 255, 255, 1);
}
.foot-part-left {
  background: rgba(0, 0, 0, 0.5);
  margin-right: -10px;
}
.line {
  height: 1px;
  background: #ffffff;
  margin: 0 6px;
  width: -webkit-fill-available;
}
.foot-part-left-item {
  padding: 6px 12px;
}
.foot-part-left-item:last-child {
  padding-top: 0px;
  font-weight: 500;
}
.want-see {
  display: flex;
  margin-top: 12px;
  margin-bottom: 6px;
}
.want-see :last-child {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(110, 117, 128, 1);
  margin-left: 4px;
}
.head-portrait-list {
  display: flex;
  overflow-x: scroll;
}
.head-portrait-list::-webkit-scrollbar {
  display: none;
}
.head-portrait-list > img {
  margin-right: 4px;
}
.intro {
  margin-top: 13px;
  display: flex;
  flex-direction: column;
}
.intro-title {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(169, 175, 184, 1);
  margin-bottom: 4px;
}
.intro-content {
  font-size: 13px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(110, 117, 128, 1);
  padding: 0;
}
.icon-zhibo {
  margin-right: 2px;
}
.circle {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  background: rgba(92, 219, 211, 1);
  border-radius: 100%;
  margin-bottom: 2px;
}
.foot-part-right-item {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
}
.exhibitor-info {
  display: flex;
  justify-content: space-between;
  margin-top: 12px;
  font-size: 13px;
  color: #0f1826;
  &-del {
    color: #3385ff;
  }
}
.productList {
  margin-top: 12px;
}
.productList-img {
  height: 90px;
  width: 90px;
  margin-right: 6px !important;
  border-radius: 4px;
}
</style>